import React from "react";
import { Briefcase, FileText, ShieldCheck, BarChart } from "lucide-react";
import "../css/partnerdashboard.css";

const PartnerDashboard = () => {
  return (
    <div className="partner-dashboard">
      <div className="partner-hero-section">
        <div className="partner-hero-left">
          <div className="partner-subscription-status">
            <h2 className="partnerdashboard-hero-heading">Subscription</h2>
          </div>
          <h2 className="partner-premium-plan">Premium Partner Plan</h2>
          <p className="partner-plan-description">Full access to all partner tools and resources</p>
          <div className="partner-status">Active</div>
          <p className="partner-renews">Renews on April 20, 2025</p>
          <p className="partner-resources-used">60% of resources used</p>
          <div className="partner-progress-bar">
            <div className="partner-progress" style={{ width: "60%" }}></div>
          </div>
        </div>

        <div className="partner-hero-right">
          <button className="partner-btn partner-view-plan-btn">View Option  Plan</button>
          <button className="partner-btn partner-manage-subscription-btn">Manage Subscription</button>
        </div>
      </div>

      <div className="partner-sections">
        <div className="partner-left">
          <h2 className="partnerdashboard-heading">
            <span style={{ color: '#192437' }}>Financial</span>{' '}
            <span style={{ color: '#F5A526' }}>Tools</span>
          </h2>
          <div className="tool-row">
            <div className="tool-item financial-tool">
              <Briefcase className="tool-icon" />
              <div className="tool-content">
                <h3>Premium Calculator</h3>
                <p>Calculate your premium rates easily.</p>
              </div>
            </div>
            <div className="tool-item financial-tool">
              <FileText className="tool-icon" />
              <div className="tool-content">
                <h3>HLV Calculator</h3>
                <p>Estimate your Human Life Value efficiently.</p>
              </div>
            </div>
            <div className="tool-item financial-tool">
              <ShieldCheck className="tool-icon" />
              <div className="tool-content">
                <h3>Commission Tracker</h3>
                <p>Track your commissions seamlessly.</p>
              </div>
            </div>
            <div className="tool-item financial-tool">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Inflation Calculator</h3>
                <p>Estimate future inflation impacts.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="partner-right">
          <h2 className="partnerdashboard-heading">
            <span style={{ color: '#192437' }}>Sales </span>{' '}
            <span style={{ color: '#F5A526' }}>Support</span>
          </h2>
          <div className="tool-row">
            <div className="tool-item sales-support">
              <FileText className="tool-icon" />
              <div className="tool-content">
                <h3>CRM Access</h3>
                <p>Access your CRM system for detailed insights.</p>
              </div>
            </div>
            <div className="tool-item sales-support">
              <ShieldCheck className="tool-icon" />
              <div className="tool-content">
                <h3>Claims Tracking</h3>
                <p>Keep track of all claims made.</p>
              </div>
            </div>
            <div className="tool-item sales-support">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Growth Pitch</h3>
                <p>Boost your sales with growth pitching tools.</p>
              </div>
            </div>
            <div className="tool-item sales-support">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Cloud Assistance</h3>
                <p>Get help with your cloud-based tools.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="partner-sections">
        <div className="partner-left">
          <h2 className="partnerdashboard-heading">
            <span style={{ color: '#192437' }}>Educational</span>{' '}
            <span style={{ color: '#F5A526' }}>Resources</span>
          </h2>
          <div className="tool-row">
            <div className="tool-item educational-resource">
              <FileText className="tool-icon" />
              <div className="tool-content">
                <h3>Product Training</h3>
                <p>Learn how to use our products efficiently.</p>
              </div>
            </div>
            <div className="tool-item educational-resource">
              <ShieldCheck className="tool-icon" />
              <div className="tool-content">
                <h3>Sales Techniques</h3>
                <p>Improve your sales techniques with expert tips.</p>
              </div>
            </div>
            <div className="tool-item educational-resource">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Compliance Update</h3>
                <p>Stay updated on regulatory changes.</p>
              </div>
            </div>
            <div className="tool-item educational-resource">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Digital Tools Tutorial</h3>
                <p>Master digital tools with detailed tutorials.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="partner-right">
          <h2 className="partnerdashboard-heading">
            <span style={{ color: '#192437' }}>Client & </span>{' '}
            <span style={{ color: '#F5A526' }}>Health Resources</span>
          </h2>
          <div className="tool-row">
            <div className="tool-item health-resource">
              <FileText className="tool-icon" />
              <div className="tool-content">
                <h3>Network Hospitals</h3>
                <p>Find the nearest hospitals in your network.</p>
              </div>
            </div>
            <div className="tool-item health-resource">
              <ShieldCheck className="tool-icon" />
              <div className="tool-content">
                <h3>Health Check Kit</h3>
                <p>Get a health check kit for better monitoring.</p>
              </div>
            </div>
            <div className="tool-item health-resource">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>Claims Tracking</h3>
                <p>Monitor and manage your health claims.</p>
              </div>
            </div>
            <div className="tool-item health-resource">
              <BarChart className="tool-icon" />
              <div className="tool-content">
                <h3>CRM Access</h3>
                <p>Access customer details with ease.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerDashboard;
